<template>
  <div>
  <mobile-menu @click.native="toggleMenu"/>
  <div class="header">
    <div class="header__mobile">
      <div class="header__mobile-green"></div>
      <div class="header__mobile-blue"></div>
    </div>

    <div class="header__wrp" style="position: relative">

      <router-link to="/" class="header-logo" >
        <img src="@/assets/img/logo.svg" alt="yurt yurtlarburada" class="header-logo__img logo-main">
        <img src="@/assets/img/logo-white.svg" alt="yurt yurtlarburada" class="header-logo__img logo-white">
        <img src="@/assets/img/logo-colored.svg" alt="yurt yurtlarburada" class="header-logo__img logo-colored">
        <img src="@/assets/img/amblem.svg" alt="yurt yurtlarburada" class="header-logo__img logo-amblem">
      </router-link>

      <div class="header-right">
        <div class="header-menu">
          <router-link
            class="header-menu__item"
            :class="{'opacity-1 color-light-green' : link.id === 3}"
            v-for="link in links"
            :key="link.id"
            :to="link.to"
          >
            {{ link.title }}
          </router-link>
        </div>
        <div class="header-menu-ctr">
          <router-link to="/iletisim" class="header-menu__item">
            <div class="btn-txt">Yurdumu Ekle</div>
            <div class="icon-font">
              <svg-icon type="icon-plus"/>
            </div>
          </router-link>
          <div class="header-menu-ctr__item header-user-drowdown">
            <v-button
              class="purple round header-login-btn"
              title='Giriş Yap'
              icon="icon-user"
              icon-position="right"
              @click.native="login"
              v-if="!type_id || type_id === 'null' || type_id === 'undefined' || type_id === ''"
            />            
            <v-button
              class="purple round header-login-btn"
              :title="(isLogin === 'true') ? first_name + ' ' + last_name : 'Giriş Yap'"
              icon="icon-user"
              icon-position="right"
              @click.native="login"
              v-if="type_id === '2'"
            />
            <v-button
              class="purple round header-login-btn"
              :title="(isLogin === 'true') ? getDormName : 'Giriş Yap'"
              icon="icon-user"
              icon-position="right"
              @click.native="login"
              v-if="type_id === '1'"
            />            
            <div class="account" v-if="isLogin">
              <div class="horizantal" style="z-index: -1; position: absolute;"></div>
              <div class="account__item user">
                <span class="account__item mycolor1" v-if="type_id === '2'">Profil</span>
                <span class="account__item mycolor1" v-if="type_id === '1'">Yurt Yönetimi</span>
              </div>
              <div v-if="type_id === '2'">
              <div class="account__item" v-for="menu in userMenu" :key="menu.id">
                <router-link :to="menu.to" class="account__item-link">{{ menu.title }}</router-link>
              </div>
              </div>
              <div v-if="type_id === '1'">
              <div class="account__item" v-for="menu in dormUserMenu" :key="menu.id">
                <router-link :to="menu.to" class="account__item-link">{{ menu.title }}</router-link>
              </div>
              </div>
              <div class="account__item exit mycursor">
                <div v-on:click="logout()" class="account__item-link">Çıkış Yap</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import MobileMenu from '@/components/MobileMenu'
import { SET_USER_INFO, UNSET_TOKEN } from '@/store/mutations.type'
import Avatar from 'vue-avatar-component'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'HeaderNav',
  components: {
    MobileMenu,
    Avatar
  },
  data () {
    return {
      // user:{},
      type_id: null,
      isDormUser: 2,
      isLogin2: false,
      links: [
        {
          id: 0,
          title: 'Şehirler',
          to: { name: 'CityList' }
        },
        {
          id: 1,
          title: 'Üniversiteler',
          to: { name: 'UniSearch' }
        },
        {
          id: 2,
          title: 'Yurt Adına Göre Ara',
          to: { name: 'DormSearch' }
        },
        {
          id: 3,
          title: 'Yurt Fiyatları',
          to: { name: 'RequestPrice' }
        }
      ],
      userMenu: [
        {
          id: 0,
          title: 'Hesap Ayarları',
          to: { name: 'UserSettings' }
        },
        {
          id: 1,
          title: 'Favorilerim',
          to: { name: 'UserFavorites' }
        },
        {
          id: 2,
          title: 'Yorumlarım',
          to: { name: 'UserComment' }
        }
/*         {
          id: 3,
          title: 'Teklifler',
          to: { name: 'UserOffers' }
        } */
      ],
      dormUserMenu: [
        {
          id: 0,
          title: 'Hesap Bilgileri',
          to: { name: 'DormUserAccount' }
        },
        {
          id: 1,
          title: 'İstatistikler',
          to: { name: 'DormUserStatistic' }
        },
        {
          id: 2,
          title: 'Mesajlar',
          to: { name: 'DormUserMessages' }
        },
        {
          id: 3,
          title: 'Yorumlar',
          to: { name: 'DormUserComments' }
        },        
        {
          id: 4,
          title: 'Yurtlar',
          to: { name: 'DormUserDorms' }
        }
      ]
    }
  },
  methods: {
    login() {
      if (this.isLogin === '') {
        this.$router.push('/uye-girisi')
      }
    },
    logout () {

/*       axios.post(`/user/logout`)
        .then(response => {
        })
        .catch(e => {
          self.errors.push(e)
        }) */

    window.localStorage.setItem('first_name1', '')
    window.localStorage.setItem('last_name1', '')
    window.localStorage.setItem('username1', ' ')
              // window.localStorage.setItem('isLogin', 'true')
    window.localStorage.setItem('access_token', '')
    window.localStorage.setItem('mail1', '')
    window.localStorage.setItem('phone1', '')
    window.localStorage.setItem('university_id1', '')
    window.localStorage.setItem('university_name1', '')
    window.localStorage.setItem('faculty_id1', '')
    window.localStorage.setItem('faculty_name1', '')
    window.localStorage.setItem('name1', '')


    window.localStorage.setItem('first_name', '')
    window.localStorage.setItem('last_name', '')
    window.localStorage.setItem('username', ' ')
              // window.localStorage.setItem('isLogin', 'true')
    window.localStorage.setItem('access_token', '')
    window.localStorage.setItem('mail', '')
    window.localStorage.setItem('phone', '')
    window.localStorage.setItem('university_id', '')
    window.localStorage.setItem('university_name', '')
    window.localStorage.setItem('faculty_id', '')
    window.localStorage.setItem('faculty_name', '')
    window.localStorage.setItem('name', '')

    window.localStorage.setItem('city_name', '')
    window.localStorage.setItem('city_slug', '')
    

    window.localStorage.setItem('district_name', '')
    window.localStorage.setItem('dormName', '')

    window.localStorage.setItem('dormAddress', '')
    window.localStorage.setItem('dormMail', '')    
    window.localStorage.setItem('memberPhone', '')
    window.localStorage.setItem('memberName', '')
    window.localStorage.setItem('pwd', '')
    window.localStorage.setItem('city', '')

      const data = { updateLogin: true, isLogin: '' }
      this.$store.commit(SET_USER_INFO, data )
      this.$store.commit(UNSET_TOKEN)
      window.localStorage.setItem('isLogin', '')
      window.localStorage.setItem('access_token', null)
      const type_id = window.localStorage.getItem('type_id')
      if (type_id == 1) {
        this.$router.push('/yurt-girisi')
      } else{
        this.$router.push('/uye-girisi')
      }
    },
    toggleMenu () {
      this.$emit('open')
    }
  },
    computed: {
    ...mapGetters(['first_name', 'last_name', 'isLogin', 'dorm_name']),  
    getLogin () {
      let login = window.localStorage.getItem('isLogin')
      return login
    },
    getDormName(){
            let dorm_name = window.localStorage.getItem('dorm_name')
            const name = dorm_name.slice(0, 10) + "..."
      return name
    }
  },
  mounted() {   
    this.type_id = window.localStorage.getItem('type_id')
  },
 watch: { '$route' () { 
    this.type_id = window.localStorage.getItem('type_id')
//   this.updateList() 
    // temporary solution  
   } },  
}
</script>

<style lang="scss">
  @import "../assets/scss/components/header";

  .mycursor {
    cursor: pointer; }

  .mycursorArrow {
    cursor: arrow; }

  .mycolor1 {
    color:#4b5ba4
  }

  .colorWhite {
    color:white;
  }
</style>
